import { isSpeechSupported } from "./speech";

export const DEFAULT_ATHLETE_NAMES = ["Constance", "Genie", "Jacques", "Yumi", "Coco", "Maria", "Miguel", "Bernie", "Taylor"];
export const DEFAULT_START_DELAY = 10;
export const DEFAULT_TIME_PER_ATHLETE = 60;
export const DEFAULT_SPEECH_ENABLED = isSpeechSupported;
export const DEFAULT_SPEECH_PROVIDER = "Web Speech"
export const DEFAULT_SPEECH_VOICE = " "